import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subscriber } from 'rxjs/Subscriber';
import 'rxjs/add/operator/map';
import { Response } from '@angular/http';
import { HttpClientService } from '../http-client/http-client.service';
import { Curriculum } from '../../models/curricula/curriculum';
import { CurriculumDataDto } from '../../models/curricula/dto/curriculum-data';

@Injectable()
export class CurriculumService {

    public curricula: Curriculum[];
    public curriculumObject: any;

    constructor(
        private http: HttpClientService
    ) {
        this.curricula = [];
        this.curriculumObject = {};
    }

    public getAll(): Observable<Curriculum[]> {
        if (!!this.curricula && this.curricula.length > 0) {
            return Observable.create((observer: Subscriber<Curriculum[]>) => {
                observer.next(this.curricula);
                observer.complete();
            });
        }
        const url = 'curriculum/all';
        return this.http.get(url).map(response => {
            const r = response.json();
            if (r.ResultCode === 1) {
                this.curricula = r.Result;
                this.curriculumObject = this.curricula.reduce((result, s) => {
                    result[String(s.Id)] = result[String(s.Id)] || {};
                    result[String(s.Id)] = s;
                    return result;
                }, {});
            } else {
                console.error('CurriculumService > getAll > response', r);
            }
            return this.curricula;
        }).catch(this.handleError);
    }

    public getAllYearSubject(curriculumId): Observable<CurriculumDataDto> {
        const url = 'curriculum/allyearssubject/' + curriculumId;
        return this.http.get(url).map(response => {
            let curricula = [];
            const r = response.json();
            if (r.ResultCode === 1) {
                curricula = r.Result;
            } else {
                console.error('CurriculumService > getAll > response', r);
            }
            return curricula;
        }).catch(this.handleError);
    }

    public getAllYearSubjects(): Observable<CurriculumDataDto[]> {
        const url = 'curriculum/allyearssubject/';
        return this.http.get(url).map(response => {
            let curricula = [];
            const r = response.json();
            if (r.ResultCode === 1) {
                curricula = r.Result;
            } else {
                console.error('CurriculumService > getAll > response', r);
            }
            return curricula;
        }).catch(this.handleError);
    }

    public add(data: any) {
        console.log('data>>>>>>>', data);
        const url = 'curriculum/add';
        return this.http.post(url, data).map(response => response.json())
            .catch(this.handleError);
    }

    public handleError(error: Response) {
        // console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }

    public delete(id: number) {
        const url: string = 'curriculum/delete/' + id;
        return this.http.delete(url).map(response => response.json())
            .catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/services/curricula/curriculum.service.ts